import GalleriesGrid from "./GalleriesGrid";
export default GalleriesGrid;
